export default function FAQSection() {
  const faqs = [
    {
      question: '如何找到91n官方最新入口地址？',
      answer: '您可以通过本导航站获取91n官方最新入口地址。我们实时同步官方更新，确保提供的入口地址安全可靠。同时建议您关注91n官方社交媒体账号，获取第一手地址更新通知。',
    },
    {
      question: '91n平台是否需要注册才能使用？',
      answer: '91n平台支持游客浏览模式，但注册账号后可以享受更多功能，如内容收藏、个性化推荐、评论互动等。注册过程简单快捷，仅需邮箱即可完成。',
    },
    {
      question: '访问91n时遇到连接问题怎么办？',
      answer: '如果遇到连接问题，请先检查网络连接是否正常，然后尝试清除浏览器缓存或使用无痕模式访问。如果问题依旧存在，可以尝试切换备用入口地址。本导航站会实时更新所有可用入口。',
    },
    {
      question: '91n平台是否安全可靠？',
      answer: '91n平台高度重视用户数据和隐私安全。平台采用SSL加密传输，支持双重验证等安全功能。我们建议用户通过本导航站提供的官方入口访问，避免使用来源不明的第三方链接。',
    },
    {
      question: '如何获取91n使用教程和帮助？',
      answer: '本导航站设有专门的使用指南和常见问题分类，涵盖从注册到高级功能的全方位教程。您也可以关注91n官方社交媒体获取最新使用技巧和公告信息。',
    },
    {
      question: '91n支持移动端访问吗？',
      answer: '91n平台全面支持移动端访问，您可以通过手机浏览器直接访问，也可以下载官方APP获得更优化的移动端使用体验。移动端功能与网页版一致，数据实时同步。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于91n的常见疑问，这里都有解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-4 text-sm font-medium text-foreground-900 list-none marker:hidden">
                <span>{faq.question}</span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-500 group-open:text-background-50 transition-colors duration-200 flex-shrink-0 ml-3">
                  <i className="ri-add-line text-xs group-open:hidden" />
                  <i className="ri-subtract-line text-xs hidden group-open:block" />
                </span>
              </summary>
              <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}